import React from "react";

export const PageHeader = ({ eyebrow, title, right, testId }) => (
  <div
    data-testid={testId}
    className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 pb-6 border-b border-neutral-900 mb-6"
  >
    <div>
      {eyebrow && (
        <p className="text-[10px] font-stats uppercase tracking-[0.3em] text-gold">
          {eyebrow}
        </p>
      )}
      <h1 className="mt-2 font-display font-black text-4xl md:text-5xl text-white leading-none">
        {title}
      </h1>
    </div>
    {right && <div className="flex flex-wrap items-center gap-2">{right}</div>}
  </div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div
    className={`bg-neutral-950 border border-neutral-900 p-5 md:p-6 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const Field = ({ label, hint, children, className = "" }) => (
  <label className={`flex flex-col gap-1.5 ${className}`}>
    <span className="text-[10px] font-stats uppercase tracking-widest text-neutral-500">
      {label}
    </span>
    {children}
    {hint && <span className="text-[11px] text-neutral-600">{hint}</span>}
  </label>
);

export const inputCls =
  "bg-neutral-900 border border-neutral-800 h-10 px-3 text-sm text-white placeholder:text-neutral-600 focus:border-gold focus:outline-none transition-colors duration-200 w-full";

export const textareaCls =
  "bg-neutral-900 border border-neutral-800 px-3 py-2 text-sm text-white placeholder:text-neutral-600 focus:border-gold focus:outline-none transition-colors duration-200 w-full";

export const selectCls =
  "bg-neutral-900 border border-neutral-800 h-10 px-3 text-sm text-white focus:border-gold focus:outline-none w-full appearance-none";

export const btnPrimary =
  "inline-flex items-center gap-2 px-4 h-10 bg-white text-black font-display uppercase tracking-widest text-xs hover:bg-gold transition-colors duration-200 whitespace-nowrap";

export const btnGhost =
  "inline-flex items-center gap-2 px-4 h-10 border border-neutral-800 text-neutral-300 font-display uppercase tracking-widest text-xs hover:text-white hover:border-neutral-700 transition-colors duration-200 whitespace-nowrap";

export const btnDanger =
  "inline-flex items-center gap-2 px-3 h-9 border border-burkina-red/40 text-burkina-red font-display uppercase tracking-widest text-[11px] hover:bg-burkina-red hover:text-white transition-colors duration-200";

export const EmptyState = ({ title, subtitle }) => (
  <div className="border border-neutral-900 line-grid py-16 px-6 text-center">
    <p className="font-display font-black text-2xl md:text-4xl text-neutral-600">
      {title}
    </p>
    {subtitle && <p className="mt-2 text-neutral-500 text-sm">{subtitle}</p>}
  </div>
);

export const StatCard = ({ label, value, hint, testId }) => (
  <div
    data-testid={testId}
    className="bg-neutral-950 border border-neutral-900 p-5 min-w-0"
  >
    <p className="text-[10px] font-stats uppercase tracking-widest text-neutral-500">
      {label}
    </p>
    <p className="mt-2 font-display font-black text-4xl md:text-5xl text-white leading-none">
      {value ?? "—"}
    </p>
    {hint && (
      <p className="mt-2 text-[10px] font-stats uppercase tracking-widest text-neutral-600">
        {hint}
      </p>
    )}
  </div>
);
